// extracted by mini-css-extract-plugin
module.exports = {"layoutContainer":"Layout-module--layoutContainer--3hL1M","childrenContainer":"Layout-module--childrenContainer--I2OUF","footer":"Layout-module--footer--Tpjf_"};